//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TaxInputItem } from './TaxInputItem';
import { PayrollUpdateItem } from './PayrollUpdateItem';

export class PaymentOrReturnPayrollUpdateItem extends PayrollUpdateItem {
    PaymentMethod?: string | null;
    CashCategoryID?: string | null;
    Taxes?: TaxInputItem[];

    constructor(initializer?: Partial<PaymentOrReturnPayrollUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PaymentOrReturnPayrollUpdateItem";
}
